import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=35378686&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=35378686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35378686",
  null
  
)

export default component.exports